<template>
  <div class="file-entry">
    <img src="@/assets/images/pdf.png" alt="" class="pdf-img" />
    <span>{{ t('该内容为独立文件') }}</span>
    <span class="file" @click="goPage">{{ t('打开文件') }}<i class="iconfont icon-gengduo"></i></span>
  </div>
</template>

<script>
import { i18nTranslateInit } from '@/utils/utility-lang'

export default {
  props: ['url'],
  data() {
    return {
      t: i18nTranslateInit.t
    }
  },
  computed: {
    title() {
      return this.$route.query.title
    }
  },
  methods: {
    goPage() {
      const url = this.url
      const title = this.title
      if (url) {
        if (url.endsWith('.pdf') || url.endsWith('.PDF')) {
          this.$router.push({
            path: '/pdf',
            query: {
              title,
              url
            }
          })
        } else {
          open(url)
        }
      } else {
        alert('文件不存在!')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.file-entry {
  display: flex;
  line-height: 19px;
  align-items: center;
  padding: 7px 8px;
  border-radius: 2px;
  font-size: 12px;
  background: var(--bg-color-8);
  overflow: hidden;
}
.pdf-img {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
.file {
  display: flex;
  align-items: center;
  margin-left: auto;
  color: var(--font-color-6);
}
</style>

<style></style>
